import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_athlete")({
  component: RouteComponent,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      const session = ctx.session;

      if (!session?.athlete) {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
